import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 300;
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
`;
